export function PageHeader({ title, highlight, level = "h1" }: { title: string; highlight: string; level?: "h1" | "h2" }) {
  const Heading = level;
  return (
    <div className="mb-12">
      <Heading className="text-4xl md:text-5xl font-bold">
        {title} <span className="gradient-text">{highlight}</span>
      </Heading>
    </div>
  );
}
